import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Stentor admin module — `/stentor` on console.francisquini.ai.
 *
 * Surface is `'admin'` — registered only on the console host. Defence-in-
 * depth: each page wraps `<RequireAdmin>` so a misconfigured router
 * cannot leak admin UI to product users.
 *
 * Backend: `stentor.francisquini.ai/v1/admin/*`. Spec:
 * docs/cockpit/dashboards/tier-2-growth-monetizacao.md §2.3.
 */
export const manifest: ModuleManifest = {
  module_id: 'stentor',
  display_name: 'Stentor',
  surface: 'admin',
  routes: [
    {
      path: '/stentor',
      component: () =>
        import('@/routes/_app/stentor').then((m) => ({
          default: m.StentorHomePage,
        })),
      title: 'Stentor — Dashboard',
      permissions: [],
    },
    {
      path: '/stentor/campaigns',
      component: () =>
        import('@/routes/_app/stentor').then((m) => ({
          default: m.StentorCampaignsPage,
        })),
      title: 'Stentor — Campanhas',
      permissions: [],
    },
    {
      path: '/stentor/campaigns/$id',
      component: () =>
        import('@/routes/_app/stentor').then((m) => ({
          default: m.StentorCampaignDetailPage,
        })),
      title: 'Stentor — Campanha',
      permissions: [],
    },
    {
      path: '/stentor/templates',
      component: () =>
        import('@/routes/_app/stentor').then((m) => ({
          default: m.StentorTemplatesPage,
        })),
      title: 'Stentor — Templates',
      permissions: [],
    },
    {
      path: '/stentor/templates/$id',
      component: () =>
        import('@/routes/_app/stentor').then((m) => ({
          default: m.StentorTemplateEditPage,
        })),
      title: 'Stentor — Template',
      permissions: [],
    },
    {
      path: '/stentor/audiences',
      component: () =>
        import('@/routes/_app/stentor').then((m) => ({
          default: m.StentorAudiencesPage,
        })),
      title: 'Stentor — Audiências',
      permissions: [],
    },
    {
      path: '/stentor/audiences/$id',
      component: () =>
        import('@/routes/_app/stentor').then((m) => ({
          default: m.StentorAudienceDetailPage,
        })),
      title: 'Stentor — Audiência',
      permissions: [],
    },
    {
      path: '/stentor/short-links',
      component: () =>
        import('@/routes/_app/stentor').then((m) => ({
          default: m.StentorShortLinksPage,
        })),
      title: 'Stentor — Short-links',
      permissions: [],
    },
  ],
}
